var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExodusWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.203 83.7645L170.449 0V46.8332L252.405 100.089L242.763 130.598H170.449V169.402H242.763L252.405 199.911L170.449 253.167V300L298.203 216.503L277.313 150.134L298.203 83.7645Z",
    fill: "url(#paint0_linear_1661_295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3007 169.402H131.346V130.598H59.0329L49.6589 100.089L131.346 46.8332V0L3.59253 83.7645L24.4831 150.134L3.59253 216.503L131.614 300V253.167L49.6589 199.911L59.3007 169.402Z",
    fill: "url(#paint1_linear_1661_295)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1661_295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 296,
    height: 300
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.204 83.7645L170.45 0V46.8332L252.405 100.089L242.763 130.598H170.45V169.402H242.763L252.405 199.911L170.45 253.167V300L298.204 216.503L277.313 150.134L298.204 83.7645Z",
    fill: "url(#paint2_linear_1661_295)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.301 169.402H131.347V130.598H59.0332L49.6592 100.089L131.347 46.8332V0L3.59277 83.7645L24.4834 150.134L3.59277 216.503L131.615 300V253.167L49.6592 199.911L59.301 169.402Z",
    fill: "url(#paint3_linear_1661_295)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1661_295)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75024,
    width: 292.5,
    height: 300,
    fill: "url(#paint4_linear_1661_295)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1661_295",
    x1: 256.875,
    y1: 320.625,
    x2: 171.3,
    y2: -32.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1661_295",
    x1: 256.875,
    y1: 320.625,
    x2: 171.3,
    y2: -32.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1661_295",
    x1: 256.875,
    y1: 320.625,
    x2: 171.3,
    y2: -32.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1661_295",
    x1: 256.875,
    y1: 320.625,
    x2: 171.3,
    y2: -32.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1661_295",
    x1: 22.5002,
    y1: 67.5,
    x2: 170.625,
    y2: 178.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#8952FF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABDFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExodusWallet);
export default __webpack_public_path__ + "static/media/exodus-wallet.e6440a5777f4e61223b65806dbbac960.svg";
export { ForwardRef as ReactComponent };